//THIS IS PROBABLY A DEAD FILE WITH THE REMOVAL OF SIGNUP BUT I'M LEAVING IT HERE FOR NOW
import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeQueryParams,
  webStorage,
} from 'sidecar-utility-library'

import { initialState, types } from './types'

export const fetchSurveyAnswer = () => ({
  [RSAA]: {
    endpoint: getApiPath(
      'acct',
      `members/surveys${makeQueryParams({
        accountUuid: webStorage.getItem('aud'),
      })}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_SURVEY_ANSWER_REQUEST,
      types.FETCH_SURVEY_ANSWER_SUCCESS,
      types.FETCH_SURVEY_ANSWER_ERROR,
    ],
  },
})

export const fetchSurveyOptions = () => ({
  [RSAA]: {
    endpoint: getApiPath(`acct`, `members/surveys/questions`),
    method: 'GET',
    types: [
      types.FETCH_SURVEY_OPTIONS_REQUEST,
      types.FETCH_SURVEY_OPTIONS_SUCCESS,
      types.FETCH_SURVEY_OPTIONS_ERROR,
    ],
  },
})

export const handleSurveySubmit = (surveyOption, otherOptionText) => ({
  [RSAA]: {
    endpoint: getApiPath(`acct`, `members/surveys`),
    method: 'POST',
    body: JSON.stringify({
      hearAboutUs: surveyOption,
      hearAboutUsOtherOption: otherOptionText,
      memberUuid: webStorage.getItem('sub'),
    }),
    types: [
      types.SUBMIT_SURVEY_ANSWER_REQUEST,
      types.SUBMIT_SURVEY_ANSWER_SUCCESS,
      types.SUBMIT_SURVEY_ANSWER_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_SURVEY_ANSWER_REQUEST:
    case types.SUBMIT_SURVEY_ANSWER_REQUEST: {
      return {
        ...state,
        survey: {
          ...state.survey,
          answer: {
            ...state.survey.answer,
            busy: true,
            error: '',
          },
        },
      }
    }
    case types.FETCH_SURVEY_OPTIONS_REQUEST: {
      return {
        ...state,
        survey: {
          ...state.survey,
          options: {
            ...state.survey.options,
            busy: true,
            error: '',
          },
        },
      }
    }

    case types.FETCH_SURVEY_ANSWER_SUCCESS:
    case types.SUBMIT_SURVEY_ANSWER_SUCCESS: {
      return {
        ...state,
        survey: {
          ...state.survey,
          answer: {
            ...state.survey.answer,
            busy: false,
            entity: payload,
          },
        },
      }
    }
    case types.FETCH_SURVEY_OPTIONS_SUCCESS: {
      return {
        ...state,
        survey: {
          ...state.survey,
          options: {
            ...state.survey.options,
            busy: false,
            entity: payload.hearAboutUs,
          },
        },
      }
    }

    case types.FETCH_SURVEY_ANSWER_ERROR:
    case types.SUBMIT_SURVEY_ANSWER_ERROR: {
      return {
        ...state,
        survey: {
          ...state.survey,
          answer: {
            ...state.survey.answer,
            busy: false,
            error: R.pathOr(
              'Something went wrong.',
              ['response', 'message'],
              payload,
            ),
          },
        },
      }
    }
    case types.FETCH_SURVEY_OPTIONS_ERROR: {
      return {
        ...state,
        survey: {
          ...state.survey,
          options: {
            ...state.survey.options,
            busy: false,
            error: R.pathOr(
              'Something went wrong.',
              ['response', 'message'],
              payload,
            ),
          },
        },
      }
    }
    default:
      return state
  }
}
